import React, { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../auth/AuthContext";
import { Bell } from "lucide-react";
import { formatLocalTimestamp } from "../lib/dateLocal";
import { pageItems } from "../lib/pageItems";

export default function Notifications() {
  const [items, setItems] = useState([]);

  const load = async () => {
    const r = await axios.get(`${API}/notifications/me`, { withCredentials: true });
    setItems(pageItems(r.data));
  };
  useEffect(() => { load(); }, []);

  const markRead = async (id) => {
    await axios.post(`${API}/notifications/${id}/read`, {}, { withCredentials: true });
    load();
  };

  return (
    <div className="max-w-[900px] mx-auto px-4 sm:px-6 lg:px-10 py-12" data-testid="notifications-page">
      <div className="eyebrow mb-2">Inbox</div>
      <h1 className="zc-headline text-4xl md:text-5xl">Notifications</h1>
      <div className="zc-card mt-8 overflow-hidden zc-stack-table min-w-0">
        {items.length === 0 && <div className="px-4 sm:px-6 py-12 text-center text-[var(--zc-text-3)] text-sm">No notifications yet.</div>}
        {items.map(n => (
          <button key={n.notification_id} onClick={() => !n.read && markRead(n.notification_id)}
            className={"zc-stack-row w-full min-w-0 text-left md:grid md:grid-cols-[24px,1fr,auto] md:items-start gap-3 px-4 sm:px-6 py-4 border-b border-[var(--zc-border)] last:border-0 hover:bg-[var(--zc-bg-3)] transition " + (n.read ? "opacity-60" : "")}
            data-testid={`notif-${n.notification_id}`}>
            <div className="shrink-0" aria-hidden><Bell size={14} className="mt-0.5" /></div>
            <div data-label="Message" className="min-w-0">
              <div className="text-sm font-semibold break-words">{n.title}</div>
              <div className="text-xs text-[var(--zc-text-2)] mt-1 break-words">{n.body}</div>
            </div>
            <div data-label="Time" className="zc-meta shrink-0 md:text-right">{formatLocalTimestamp(n.created_at) || "—"}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
